import { IJsonQueryTerm } from './term';

export enum ESortVariants {
  /** Заканчивается период действия **/
  AboutToEnd = 'aboutToEnd',
  /** Сначала новые **/
  NewFirst = 'newFirst',
  /** По популярности **/
  Popularity = 'popularity',
}

export type IJsonQuerySortType = IJsonQueryTerm<ESortVariants>;
